import(/* webpackMode: "eager" */ "/app/apps/store/src/shared/components/scrollUp/ScrollUp.tsx");
import(/* webpackMode: "eager" */ "/app/apps/store/src/shared/styles/Rules.module.scss");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js")